import React, { FC, ReactNode } from "react"
import { HEADING } from "../../utils/styles"
import { container, heading1, heading2, heading3, heading4 } from "./styles"
/** @jsx jsx */
import {css, jsx } from "@emotion/react"
interface HeadingProps {
  type?: HEADING
  children?: ReactNode
}

/**
 * Header components for terms of use
 *
 * @param {*} { children, type }
 * @returns
 */
const Heading: FC<HeadingProps> = ({ children, type }) => {
  let headingStyle = heading1

  switch (type) {
    case HEADING.H2:
      headingStyle = heading2
      break
    case HEADING.H3:
      headingStyle = heading3
      break
    case HEADING.H4:
      headingStyle = heading4
      break
    case HEADING.H1:
    default:
      break
  }

  return <div css={css`${container} ${headingStyle}`}>{children}</div>
}

export default Heading
